import React from 'react';
import { Company } from '../../../../model/user/Company';
import { UserRoles } from '../../../../enum/UserRoles';
import { useTranslation } from 'react-i18next';
import { CustomImageHandler } from '../../../../shared/components/CustomImageHandler';
import ManagingUsers from './ManagingUsers';
import { User } from '../../../../model/user/User';
import { getTruncatedData } from '../../../../utils/helpers/getTruncatedData';
import TooltipOverlay from '../../../../shared/components/tooltip/Tooltip';

interface ICompanyDetailCardProps {
    company?: Company;
    displayUsers?: boolean;
    companyMaster?: User;
}

export function CompanyDetailCard({ company, displayUsers, companyMaster }: ICompanyDetailCardProps) {
    const { t } = useTranslation();
    const brandMaster = companyMaster
        ? companyMaster
        : company?.companyUsers?.find(item => item.userType === UserRoles.BRAND_MASTER);

    const companyName = company?.displayName ?? '';
    const { truncatedName, isTruncated } = getTruncatedData(companyName ?? '', 35);

    return (
        <>
            <div className=" d-flex overflow-auto align-items-center">
                <div>
                    <CustomImageHandler
                        style={{ width: 130, height: 130 }}
                        photoPath={company?.profilePhoto?.thumbnail ?? ''}
                        thumbnailPath={company?.profilePhoto?.thumbnail ?? ''}
                        classes="shadow-sm default-radius img-cover"
                        altTag={company?.profilePhoto?.name ?? ''}
                    />
                </div>
                <div className="ml-lg-3 ml-2 d-flex flex-column justify-content-between w-100">
                    <TooltipOverlay content={isTruncated ? companyName : ''}>
                        <h6>{truncatedName}</h6>
                    </TooltipOverlay>
                    <div className="d-flex justify-content-between mt-2">
                        <div>
                            <p className="mb-1">
                                <i className="fi fi-rr-marker text-primary mr-1" />
                                {t(`general.countries.${company?.contact?.country}`)}
                                {', '} {company?.contact?.city ? company?.contact?.city + ', ' : ''}{' '}
                                {company?.contact?.zip ? company?.contact?.zip + ', ' : ''}{' '}
                                {company?.contact?.street ?? ''}
                            </p>
                            <p className="mb-1">
                                <i className="fi fi-rr-phone-call text-primary mr-1" />
                                {company?.contact?.phone ?? company?.bank?.accountPhone ?? '-'}
                            </p>
                            <p className="mb-0">
                                <i className="fi fi-rr-envelope text-primary mr-1 align-middle" />
                                {brandMaster?.email ?? '-'}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            {displayUsers && (
                <>
                    <ManagingUsers
                        users={company?.companyUsers.filter(item => item.userType === UserRoles.BRAND_MASTER) ?? []}
                        title="brand.campaign.dashboard.modal.campaign_admins"
                    />
                    <ManagingUsers
                        users={company?.companyUsers.filter(item => item.userType !== UserRoles.BRAND_MASTER) ?? []}
                        title="brand.campaign.dashboard.modal.campaign_managers"
                    />
                </>
            )}
        </>
    );
}
